



















import { apiProvider } from '@/modules/kartoteka/vozidlo/api';

import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME } from '../constants';

type DataType = { ZAZNAM_ID: number; TEXT: string; TYPKOD: string; X_TABLPOZICE_ZKRAC: string; VYROBEKVOZ_OZN: string; VYKON: number; OBJEM: number };

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		showLabel: { type: Boolean, default: true },
		popis: { type: String, default: undefined },
		isPopisVisible: { type: Boolean, default: undefined },
		isPopisDisabled: { type: Boolean, default: undefined },
		text: { type: String, default: undefined },
		filter: { type: Object },
		autocomplete: { type: Boolean, default: false },
	},
	data() {
		return {
			storeObject: NAME,
			emptyObject: {
				isClear: true,
				value: null,
				text: null,
				typkod: null,
				vykon: null,
				objem: null,
			},
		};
	},
	computed: {
		inputSpanCmp() {
			return this.isPopisVisible ? 12 : 24;
		},
		popisDisabledCmp() {
			return this.isDisabled || this.isPopisDisabled;
		},
		textCmp: {
			get() {
				return this.text;
			},
			set(val) {
				this.$emit('update:text', val);
			},
		},
	},
	methods: {
		fetchTypKod(this: { apiProvider: any }, filter: object) {
			return apiProvider.typKodChange(filter);
		},
		dbToBaseMapper(data: DataType) {
			return {
				value: data.ZAZNAM_ID,
				text: data.TEXT,
				typkod: data.TYPKOD,
				tablpozice: data.X_TABLPOZICE_ZKRAC,
				vyrobekvozozn: data.VYROBEKVOZ_OZN,
				vykon: data.VYKON,
				objem: data.OBJEM,
			};
		},
		querySearchAsync(queryString: string, cb: any) {
			this.apiQuery({
				VyrobekvozOzn: this.filter.VyrobekvozOzn,
				Typkod: queryString,
				ModelRok: this.filter.ModelRok,
			}, cb);
		},
		apiQuery(filterSearch: any, cb: any) {
			apiProvider.typKodChange(filterSearch).then((res: any) => {
				cb([]);
				if (res.data.TypkodText) {
					this.$emit('updateTypDep', res.data);
				}
			});
		},
	},
});
